import { ViewState } from './ViewState';

export enum SaveOrderAsyncViewState {
  PAYING = 6,
  WAITINGFAILED = 7, // TODO remove this state, replace with error message
  AWAITING_PAYMENT = 8
}

export type SaveOrderViewState = ViewState | SaveOrderAsyncViewState;
